import React, { useEffect, useRef, useState } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

export default function Form({ siteKey, token, setToken }) {
    
    const captchaRef = useRef(null);

    const onLoad = () => {
        // this reaches out to the hCaptcha JS API and runs the
        // execute function on it. you can use other functions as
        // documented here:
        // https://docs.hcaptcha.com/configuration#jsapi
        captchaRef.current.execute();
    };

    useEffect(() => {

        if (token)
            console.log(`hCaptcha Token: ${token}`);

    }, [token]);



    return (
        <form>
            <HCaptcha
                sitekey={siteKey}
                onLoad={onLoad}
                onVerify={setToken}
                ref={captchaRef}
            />
        </form>
    );
}